import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ProfileService } from '@shared/auth';

@Injectable({
  providedIn: 'root',
})
export class ProjectApiService {
  private http = inject(HttpClient);
  private profileService = inject(ProfileService);

  private baseUri = null;

  constructor() {
    this.profileService.apiUrl$.subscribe(apiUrl => {
      this.baseUri = `${apiUrl}/api/projecttasks`;
    });
  }

  getScheduled(): Observable<any> {
    const url = `${this.baseUri}/scheduled`;
    return this.http.get(url);
  }

}

